import React from "react";
import { CreateContainer } from "./ContainerCreate";
import MostRecentContainer from "./MostRecentContainer";
import { getPreviousPosts } from "../api/getMostRecentPosts";

class PreviousContainer extends MostRecentContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, items: [] };
  }
}

PreviousContainer.defaultProps = { count: 30 };
export default CreateContainer(getPreviousPosts, MostRecentContainer);
